import { memo } from 'react';
import { X } from 'lucide-react';
import Button from './ui/Button';
import StatisticsPanel from './StatisticsPanel';

/**
 * StatisticsModal Component
 * Full-screen modal for viewing detailed statistics
 * Memoized to prevent unnecessary re-renders
 */
const StatisticsModal = memo(function StatisticsModal({
  isOpen,
  onClose,
  statisticsHook,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-3xl font-bold text-gray-800">
            📊 Din Statistik
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-200 rounded-full transition-colors"
            aria-label="Luk statistik"
          >
            <X size={28} className="text-gray-600" />
          </button>
        </div>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto p-6">
          <StatisticsPanel
            statistics={statisticsHook.statistics}
            getAccuracyPercentage={statisticsHook.getAccuracyPercentage}
            getOperationAccuracy={statisticsHook.getOperationAccuracy}
            getDifficultyAccuracy={statisticsHook.getDifficultyAccuracy}
            getWeakestOperation={statisticsHook.getWeakestOperation}
            getSuggestedDifficulty={statisticsHook.getSuggestedDifficulty}
          />
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 bg-white">
          <Button onClick={onClose} size="lg" fullWidth>
            Luk
          </Button>
        </div>
      </div>
    </div>
  );
});

export default StatisticsModal;
